import { useQuery, gql } from "@apollo/client";

const DOWNLOAD_QUERY = gql`
  query getFileURL($slug: String!) {
    fileDownload(slug: $slug) {
      url
    }
  }
`;

interface DownloadQueryPayload {
  fileDownload: {
    url: string;
  };
}

export const useExportFileDownload = (slug: string) => {
  const { data, loading } = useQuery<DownloadQueryPayload>(DOWNLOAD_QUERY, {
    variables: { slug },
    skip: !slug,
    context: {
      clientName: "companySearch",
    },
  });

  return {
    url: data?.fileDownload?.url,
    isLoading: loading,
  };
};
